// Admin "view as" try-it homework (2026-09-25). While an admin views as a
// student, homework answers are graded here in the browser and never sent:
// startHomework (a read of a set the student already opened) carries each
// question's answer key, and the grade rule below mirrors the server's
// (claude-student-api submitHomeworkAnswer) and SessionUI's gradeAnswer.
// The student's real answers seed each set, so progress picks up where they
// left off; the admin's answers live only in this page load.

const sets = new Map(); // `${classID}#${hwId}` -> { byId, answers, total }
const keyOf = (classID, hwId) => `${classID}#${hwId}`;

// trim + exact match, "3 or -3" alternatives (same as the server).
export function gradeLocally(question, given) {
  const raw = String(given ?? '').trim();
  if (!raw) return false;
  const ans = String(question?.Answer ?? '').trim();
  if (ans.toLowerCase().includes(' or ')) return ans.split(/\s+or\s+/i).map((s) => s.trim()).includes(raw);
  return raw === ans;
}

export function seedHomework({ classID, hwId } = {}, res) {
  const questions = Array.isArray(res?.questions) ? res.questions : [];
  sets.set(keyOf(classID, hwId), {
    byId: new Map(questions.map((q) => [q.recordID, q])),
    answers: { ...(res?.progress?.answers || {}) },
    total: Number(res?.hw?.count) || questions.length,
  });
}

// Same response shape as the server: { ok, correct, answered, done } or
// { ok, duplicate } for a question already answered.
export function submitLocalAnswer({ classID, hwId, recordID, selected } = {}) {
  const set = sets.get(keyOf(classID, hwId));
  const question = set?.byId.get(recordID);
  if (!question) {
    const err = new Error('This question is not loaded. Reload the page.');
    err.status = 404;
    throw err;
  }
  if (set.answers[recordID]) return { ok: true, duplicate: true, viewOnly: true };
  const correct = gradeLocally(question, selected);
  set.answers[recordID] = { selected, correct, at: new Date().toISOString() };
  const answered = Object.keys(set.answers).length;
  return { ok: true, correct, answered, done: answered >= set.total, viewOnly: true };
}

export function resetLocalHomework() { sets.clear(); }
